
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { CompanyContactModel } from './Entities.GormCrm.CompanyContact';
import { ContactPhoneModel } from './Entities.GormCrm.ContactPhone';
import { Model, ModelProperty } from 'models/Model';


export class ContactModel extends Model<ContactModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'firstName', type: 'string' },
		{ name: 'emailAddress', type: 'string' },
		{ name: 'role', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'lastName', type: 'string' },
		{ name: 'fullName', type: 'string' },
		{ name: 'companyBillingContacts', type: 'CompanyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'companyContacts', type: 'CompanyContactModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyContactModel }, properties: () => { return CompanyContactModel.classProperties } },
		{ name: 'companyPrimaryContacts', type: 'CompanyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'contactPhones', type: 'ContactPhoneModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ContactPhoneModel }, properties: () => { return ContactPhoneModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public firstName: string;
	public emailAddress: string;
	public role: string;
	public created?: Date;
	public deleted?: Date;
	public lastName: string;
	public fullName: string;
	public companyBillingContacts: CompanyModel[];
	public companyContacts: CompanyContactModel[];
	public companyPrimaryContacts: CompanyModel[];
	public contactPhones: ContactPhoneModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.firstName = '';
		this.emailAddress = '';
		this.role = '';
		this.created = undefined;
		this.deleted = undefined;
		this.lastName = '';
		this.fullName = '';
		this.companyBillingContacts = [];
		this.companyContacts = [];
		this.companyPrimaryContacts = [];
		this.contactPhones = [];
		
	}
	getProperties(){
		return ContactModel.classProperties;
	}
}

